import { root, id } from './post';

export const post = {
  ...root,
  id,
};
